export const SIDEBAR_WIDTH_EXPANDED = '192px';
export const SIDEBAR_WIDTH_MINIMIZED = '52px';
export const TOP_BAR_WINDOW_CONTROLS_RAIL_WIDTH = '172px';
